<template>
    <form @submit="persistSection">

        <b-form-checkbox id="aLaUne" class="mb-2 mt-2"
                         v-model="sectionDatas.aLaUne.datas" value="true"
                         unchecked-value="false">
            Mettre à la une
        </b-form-checkbox>

        <b-form-checkbox id="lierALaVostokE" class="mb-2 mt-2"
                         v-model="sectionDatas.lierALaVostokE.datas" value="true"
                         unchecked-value="false">
            Lier à La VostokE
        </b-form-checkbox>

        <b-form-checkbox id="selectionVostokPlus" class="mb-2 mt-2"
                         v-model="sectionDatas.selectionVostokPlus.datas" value="true"
                         unchecked-value="false">
          Ajouter à la sélection Vostok+
        </b-form-checkbox>

        <fieldset class="form-group">
          <legend>Programme</legend>
          <label class="sr-only" for="programme">Programme</label>
          <select id="programme" class="form-control" v-model="sectionDatas.programme.datas">
            <option v-for="programme in availableProgrammes" v-bind:value="{ id: programme.id, name: programme.name }">
              {{programme.name}}
            </option>
          </select>
        </fieldset>

        <fieldset class="form-group">
            <legend>Contenu dédié WordPress</legend>
            <i>description podcast utilisée si vide</i>
            <label class="sr-only" for="contenuWP">Contenu WP</label>
            <textarea id="contenuWP" class="form-control" v-model="sectionDatas.contentWP.datas"></textarea>
        </fieldset>

        <fieldset class="form-group">
            <legend>Extrait WordPress</legend>
            <label class="sr-only" for="extraitWP">Extrait WP</label>
            <textarea id="extraitWP" class="form-control" v-model="sectionDatas.extraitWP.datas" :maxlength="100"></textarea>
            <div class="char-count" v-text="sectionDatas.extraitWP.datas ? sectionDatas.extraitWP.datas.length + '/100': 0 + '/100'"></div>
        </fieldset>

        <fieldset class="form-group">
            <legend>Description Facebook</legend>
            <label class="sr-only" for="descriptionFB">description Facebook</label>
            <textarea id="descriptionFB" class="form-control" v-model="sectionDatas.descriptionFB.datas"></textarea>
        </fieldset>

        <fieldset class="form-group">
            <legend>Description Twitter</legend>
            <label class="sr-only" for="descriptionTW">description Twitter</label>
            <textarea id="descriptionTW" class="form-control" v-model="sectionDatas.descriptionTW.datas" :maxlength="280"></textarea>
            <div class="char-count" v-text="sectionDatas.descriptionTW.datas ? sectionDatas.descriptionTW.datas.length + '/280': 0 + '/280'"></div>
        </fieldset>

        <fieldset class="form-group">
            <legend>Planification publication WP</legend>
            <i>publication immédiate si vide</i>
            <date-picker v-model="sectionDatas.wpPublicationDateTime.datas"></date-picker>
        </fieldset>

        <fieldset class="form-group">
          <upload-file v-if="showUpload" :type="'imageUneWP'" :fileId="sectionDatas.imageUneWP.datas"
                       :formats="['jpeg','jpg']" :types="['image/jpeg', 'image/png']"
                       v-on:push-file="pushFile"></upload-file>
        </fieldset>

        <fieldset class="form-group">
          <upload-file v-if="showUpload" :type="'imageBackgroundWP'" :fileId="sectionDatas.imageBackgroundWP.datas"
                       :formats="['jpeg','jpg']" :types="['image/jpeg', 'image/png']"
                       v-on:push-file="pushFile"></upload-file>
        </fieldset>

        <button type="submit" class="btn btn-primary" v-bind:disabled="editPending">Valider cette étape</button>
    </form>
</template>

<script>

  // Import required dependencies
  import 'bootstrap/dist/css/bootstrap.css';

  // Import this component
  import datePicker from 'vue-bootstrap-datetimepicker';

  // Import date picker css
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

  import UploadFile from './UploadFile'

  import bdd from "../../api/bdd"

  export default {

    name: 'AdvancedForm',

    props: {
      subject: Object,
      editPending: false,
    },

    components: {
      datePicker,
      UploadFile
    },

    data() {
      return {
        sectionName: 'advanced',
        showUpload: false,
        idtinymce: 'idtinymce',
        sectionDatas: {
          aLaUne: {
            name: 'mettre à la une',
            datas: false
          },
          contentWP: {
            name: 'contenu wp',
            datas: ''
          },
          extraitWP: {
            name: 'extrait wp',
            datas: ''
          },
          wpPublicationDateTime: {
            name: 'date publication wp',
            datas: null
          },
          descriptionFB: {
            name: 'description FB',
            datas: ''
          },
          descriptionTW: {
            name: 'description TW',
            datas: ''
          },
          imageUneWP: {
            name: 'image une WP',
            datas: null
          },
          imageBackgroundWP: {
            name: 'image une WP',
            datas: null
          },
          lierALaVostokE: {
            name: 'lier à la VostokE',
            datas: false
          },
          selectionVostokPlus:{
            name: 'sélection Vostok +',
            datas: false
          },
          programme: {
            name: 'format',
            datas: {
              id: null,
              name: ''
            }
          }
        },
        availableProgrammes: [],
      }
    },

    mounted() {
      this.sectionDatas.contentWP.datas = this.subject.contentWP
      this.sectionDatas.extraitWP.datas = this.subject.extraitWP
      this.sectionDatas.descriptionFB.datas = this.subject.descriptionFB
      this.sectionDatas.descriptionTW.datas = this.subject.descriptionTW
      this.sectionDatas.aLaUne.datas = this.subject.aLaUne
      if (this.subject.wpPublicationDateTime !== null) {
        this.sectionDatas.wpPublicationDateTime.datas = new Date(this.subject.wpPublicationDateTime)
      }
      this.sectionDatas.imageBackgroundWP.datas = this.subject.imageBackgroundWP
      this.sectionDatas.imageUneWP.datas = this.subject.imageUneWP
      this.sectionDatas.lierALaVostokE.datas = this.subject.lierALaVostokE
      this.sectionDatas.selectionVostokPlus.datas = this.subject.selectionVostokPlus
      // on récupère les programmes disponibles
      bdd.getAvailableLabel('programmes')
        .then(programmes => {
          this.availableProgrammes = programmes
          this.availableProgrammes.sort((a, b) => (a.name.localeCompare(b.name)))
          console.log('programmes disponibles : ', this.availableProgrammes)
          // puis les programmes disponbibles
          if (this.subject.programme !== null) {
            this.setProgramme()
          }
        })
      this.$emit('push-section', this.sectionDatas, this.sectionName)
      this.showUpload = true
    },

    methods: {
      persistSection: function (e) {
        e.preventDefault()
        console.log('persist')
        this.$emit('push-edit', this.sectionDatas, this.sectionName)
      },
      pushFile: function (type, id, url) {
        this.sectionDatas[type].datas = id
        console.log(this.sectionDatas[type].datas)
      },
      setProgramme: function () {
        // et on met à jour notre programme actuel
        // on prépare notre ID de programme pour la comparaison (car on la veux sans le préfixe de l'API
        let index = this.subject.programme.lastIndexOf('/') + 1
        let programmeCleanId = this.subject.programme.substr(index)
        for (let i = 0; i < this.availableProgrammes.length; i++) {
          if (programmeCleanId === this.availableProgrammes[i].id) {
            this.sectionDatas.programme.datas.id = this.availableProgrammes[i].id
            this.sectionDatas.programme.datas.name = this.availableProgrammes[i].name
          }
        }
      }
    }

  }

</script>



// WEBPACK FOOTER //
// src/components/EditSub/AdvancedForm.vue